import ExternalDoorInRowMeasurementValues from './ExternalDoorInRowMeasurementValues';

export default ExternalDoorInRowMeasurementValues ;